import { render } from "./WorkloadView.vue?vue&type=template&id=6247a8f7"
import script from "./WorkloadView.vue?vue&type=script&lang=js"
export * from "./WorkloadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__